import { AxiosResponse } from "axios";
import { GradeEntity, GradeEntityInput } from "./grade.types";
import { api } from "../api";

export const getGrades = async () => {
  try {
    const response: AxiosResponse<GradeEntity[]> = await api.get("/grades");
    return response.status === 200 ? response.data : [];
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getGradeById = async (id: number) => {
  try {
    const response: AxiosResponse<GradeEntity> = await api.get("/grades/" + id);
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const createGrade = async (data: GradeEntityInput) => {
  try {
    const response: AxiosResponse<GradeEntity> = await api.post(
      "/grades",
      data
    );

    return response.status === 201 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const updateGrade = async (id: number, data: GradeEntityInput) => {
  try {
    const response: AxiosResponse<GradeEntity> = await api.patch(
      "/grades/" + id,
      data
    );

    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const deleteGrade = async (id: number) => {
  try {
    const response: AxiosResponse<GradeEntity> = await api.delete(
      "/grades/" + id
    );

    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
